import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { ServiceService } from '../../../services/service.service';

@Component({
  selector: 'app-form-service',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    InputNumberModule,
    ButtonModule,
    CheckboxModule
  ],
  templateUrl: './form-service.component.html'
})
export class FormServiceComponent implements OnInit {

  form!: FormGroup;
  isEditMode = false;
  id!: number; 

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private serviceService: ServiceService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      name: ['', Validators.required],
      description: [''],
      price: [0, [Validators.required, Validators.min(0)]],
      active: [true]
    });

    const idParam = this.activatedRoute.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
      this.isEditMode = true;
      
      this.serviceService.getById(this.id).subscribe({
        next: (data) => {
          this.form.patchValue(data.data);
        },
        error: (error) => {
          console.log(error);
        }
      })
    }
  }

  goBack() {
    this.router.navigate(['/app/services']);
  }

  onSubmit() {
    if (this.form.invalid) return;

    if(this.isEditMode){
      this.serviceService.update(this.id, this.form.value).subscribe({
          next: ()=> {
            this.goBack();
          },
          error: (error) => {
            console.log(error);
          }
        });
    }else{
      this.serviceService.create(this.form.value).subscribe({
          next: ()=> {
            this.goBack();
          },
          error: (error) => {
            console.log(error);
          }
        });
    }
  }
}

